import {CampaignRecord,PageState,PageName,ColumnIds,ResetPageDto,CLinkOwnerOption, QueryString, IncludeExclude} from "../utils/types";
import {getGroupByItemsPerPage} from "../utils/misc";
import StateHelper from "../utils/StateHelper";
import {IdName} from "../utils/types";
import dayjs from "../utils/dayjs";
import * as H from 'history';
import { CommonRequests } from "./CommonRequests";

let _history:H.History<H.LocationState> = null;
let _basePath:string = null;

function getValidGroupByNamesFromState(currentStateString : string, page : string) : string {
  const validGroupbyElements : IdName[] = getGroupByItemsPerPage(page);
  
  const validNames : string[] = validGroupbyElements.map( (element : IdName) => element.id);

  let stateGroupbyElements : string[] = currentStateString.split(",");

  let validElements = stateGroupbyElements.filter( (e : string) => validNames.includes(e));

  const value = validElements.join(",");

  return value;
}

function getCommonQueryParameters (state : PageState, page : string) : QueryString {
  const queryParams:QueryString = {
    dateStart: dayjs.utc(state.dateStart).format("YYYY-MM-DD"),
    dateEnd: dayjs.utc(state.dateEnd).format("YYYY-MM-DD")
  };

  if (state.groupBy !== null) {
    queryParams.groupBy = getValidGroupByNamesFromState(state.groupBy, page);
  }

  if (state.placements == null || state.placements.length === 0) {
    if (state.publishers != null && state.publishers.length > 0) {
      let publishersAndSites = "";
      for (let index = 0; index < state.publishers.length; index++) {
        if(index > 0){
          publishersAndSites += ",";
        }
        publishersAndSites += state.publishers[index];
      }
      (queryParams as any)['placements' + state.placementsIncludeExclude.toString()] = publishersAndSites;
    }
  } else {
    if (state.placements != null && state.placements.length > 0) {
      let placements = "";
      let placementsIncludeOrExclude = (queryParams as any)['placements' + state.placementsIncludeExclude.toString()];
      for (let index = 0; index < state.placements.length; index++) {
        if(index > 0){
          placements += ",";
        }          
        placements += state.placements[index];
      }
      if (placementsIncludeOrExclude) {
        placementsIncludeOrExclude = placementsIncludeOrExclude + "," + placements;
      } else {
        placementsIncludeOrExclude = placements;
      }
      (queryParams as any)['placements' + state.placementsIncludeExclude.toString()] = placementsIncludeOrExclude;
    }
  }

  if (state.trafficTypes !== null) {
    (queryParams as any)['trafficTypes' + state.trafficTypesIncludeExclude.toString()] = state.trafficTypes;
  }

  return queryParams;        
}

export const PagesHelper = {
  setHistory(historyObject:H.History<H.LocationState>) {
    _history = historyObject;
  },

  setBasePath(basePath: string) {
    _basePath = basePath;
  },

  getBasePath(): string {
    return _basePath;
  },

  historyPushFromPageState: function () {
    const pageState : PageState = StateHelper.getPageState();
    const newUrl = this.getPageUrl(pageState.page, pageState);
    _history.push(newUrl);
  },

  historyReplaceFromPageState: function () {
    const pageState : PageState = StateHelper.getPageState();
    const newUrl = this.getPageUrl(pageState.page, pageState);
    _history.replace(newUrl);
  },

  historyPush: function(pageUrl: string) {
    _history.push(pageUrl);
  },

  getPageUrl: function (page : string, pageState : PageState): string {
    let url = "/" + page + "?";

    // only viewAs for campaignLinks and campaignLookup
    if (page === PageName.campaignLinks || page === PageName.campaignLookup) {
      // viewAs
      if (pageState.viewAs !== null) {
        url += "viewAs=" + encodeURIComponent(pageState.viewAs);
      }
      return url;
    }
    url += this.getCommonUrlSearch(pageState);

    // countries
    if (page === PageName.overall || page === PageName.products) {
      if (pageState.countries != null && pageState.countries.length) {
        url += `&countries${pageState.countriesIncludeExclude.toString()}=${pageState.countries}`;
      }
    }

    // products and campaigns
    if (page === PageName.products || page === PageName.performanceReports) {
      if ( pageState.productIds !== null && pageState.productIds.length > 0 ){
        url += `&products${pageState.productsIncludeExclude.toString()}=${pageState.productIds}`;
      }
  
      if (pageState.campaigns && pageState.campaigns.length > 0 ) {
        pageState.campaigns = pageState.campaigns.map((campaign) => !campaign.includes(":") ? campaign + ":***" : campaign);
        url += `&campaigns${pageState.campaignsIncludeExclude.toString()}=${pageState.campaigns.join(",")}`;
      }
    }

    if (page === PageName.products) {
      // queryFlags
      if (pageState.queryFlags != null && pageState.queryFlags.length > 0 ) {
        url += "&queryFlags=" + Array.from(pageState.queryFlags).join(",");
      }
      // clinks
      if (pageState.cLinks && pageState.cLinks.length > 0 ) {
        url += `&clinks${pageState.cLinksIncludeExclude.toString()}=${pageState.cLinks.join(",")}`;
      }
    }

    // viewAs
    if (pageState.viewAs !== null) {
      url += "&viewAs=" + encodeURIComponent(pageState.viewAs);
    }

    // pivotBy
    if (pageState.pivotBy !== null) {
      url += "&pivotBy=" + pageState.pivotBy;
    }

    return url;
  },

  getInitialPageUrl(page : string) : string {
    let url = "?dateStart=" + dayjs.utc().format("YYYY-MM-DD");
    url += "&dateEnd=" + dayjs.utc().format("YYYY-MM-DD");

    if ( page === PageName.products ){
      url += "&groupBy=" + ColumnIds.productID;
    }
    else{
      url += "&groupBy=" + ColumnIds.apptapPublisherID;
    }
    return url;
  },

  getCommonUrlSearch : function(state : PageState) {
    let url = "dateStart=" + dayjs.utc(state.dateStart).format("YYYY-MM-DD");
    url += "&dateEnd=" + dayjs.utc(state.dateEnd).format("YYYY-MM-DD");

    let placementsIncludeIds : string = "";
    let placementsAdded : number = 0;
    if (state.publishers != null && state.publishers.length > 0) {
      for (let index = 0; index < state.publishers.length; index++) {
        if (index > 0) {
          placementsIncludeIds += ",";
        }
        placementsIncludeIds += state.publishers[index];
        placementsAdded++;
      }

      // url += "&placementsInclude=" + pIds;
    }

    if (state.placements != null && state.placements.length > 0) {
      for (let index = 0; index < state.placements.length; index++) {
        if (placementsAdded > 0) {
          placementsIncludeIds += ",";
        }
        placementsIncludeIds += state.placements[index];
        placementsAdded++;
      }

      // url += "&placements=" + placements;
    }
    if( placementsIncludeIds !== "" ){
      url += `&placements${state.placementsIncludeExclude.toString()}=${placementsIncludeIds}`;
    }

    if (state.trafficTypes != null) {
      url += `&trafficTypes${state.trafficTypesIncludeExclude.toString()}=${state.trafficTypes}`;
    }

    if (state.groupBy != null) {
      url += "&groupBy=" + state.groupBy;
    }

    return url;
  },

  getQueryParameters(page : string, includeRequestId = true) : QueryString {
    const pageState:PageState = StateHelper.getPageState();
    const queryParams:QueryString = getCommonQueryParameters(pageState, page);

    if (page === PageName.overall || page === PageName.products ) {
      if (pageState.countries !== null && pageState.countries.length) {
        (queryParams as any)['countries' + pageState.countriesIncludeExclude.toString()] = pageState.countries;
      }
    }
    if (page === PageName.products) {
      if (pageState.queryFlags != null && pageState.queryFlags.length > 0 ) {
        queryParams.queryFlags = Array.from(pageState.queryFlags).join(",");
      }
    }

    if (page === PageName.products) {
      if ( pageState.cLinks !== null){
        (queryParams as any)['clinks' + pageState.cLinksIncludeExclude.toString()] = pageState.cLinks.join(",");
      }
    }
    if (page === PageName.products || page === PageName.performanceReports ){
      if ( pageState.productIds !== null && pageState.productIds.length > 0 ){
        (queryParams as any)['products' + pageState.productsIncludeExclude.toString()] = pageState.productIds;
      }
  
      if ( pageState.campaigns ){
        (queryParams as any)['campaigns' + pageState.campaignsIncludeExclude.toString()] = pageState.campaigns.join(",").replaceAll("<untracked>", "***");
      }
    }

    return queryParams;
  },

  clearState : function (pageState : PageState){
    pageState.countries = null;
    pageState.dateEnd = null;
    pageState.dateStart = null;
    pageState.groupBy = null;
    pageState.placements = null;
    pageState.trafficTypes = null;
    pageState.campaigns = null;
    pageState.productIds = null;
    pageState.cLinks = null;
    pageState.queryFlags = null;
    pageState.publishers = null;
    pageState.pivotBy = null;
  },

  getCampaignSourceAliasAndID : function(c : CampaignRecord): string {
    return (c.campaignSourceAlias == null ? "***" : c.campaignSourceAlias) + ":" + (c.campaignId == null ? "***" : c.campaignId);
  },
  fromCLinkOwnerOptionToString : function(c : CLinkOwnerOption): string {
    return c.record instanceof Object ? c.record.cLinkId : c.record;
  },

  getCampaignIdFromString : function( s : string): string{
    let cId = "";
    if( s === null || s === undefined){
      return cId;
    }

    if( s.startsWith("***:")){
      cId = s.split(":")[1];
    }
    return cId;
  },

  resetFilters : function ( page : string, resetPageDto : ResetPageDto, searchFunction : any) : void {
    try{

      const pageState : PageState = StateHelper.getPageState();

      resetPageDto.trafficSourcesRef.current.clear();  

      if( resetPageDto.countriesRef ) {
        resetPageDto.countriesRef.current.clear();
      }
      if( resetPageDto.trafficTypesRef ){
        resetPageDto.trafficTypesRef.current.clear();
      }

      resetPageDto.groupByRef.current.clear();
      resetPageDto.placementsRef.current.clear();

      if( resetPageDto.productsRef !== null && resetPageDto.productsRef.current !== null) {
        resetPageDto.productsRef.current.clear();
      }
      if (resetPageDto.campaignsRef !== null && resetPageDto.campaignsRef.current !== null) {
        resetPageDto.campaignsRef.current.clear();
      }
      if (resetPageDto.cLinksRef !== null && resetPageDto.cLinksRef.current !== null) {
        resetPageDto.cLinksRef.current.clear();
      }
      if (resetPageDto.queryFlagsRef !== null && resetPageDto.queryFlagsRef.current !== null) {
        resetPageDto.queryFlagsRef.current.clear();
      }
      PagesHelper.clearState( pageState );

      if( page === PageName.overall){
        pageState.groupBy = ColumnIds.apptapPublisherID;
      }
      else {
        pageState.groupBy = ColumnIds.productID;
      }

      pageState.dateStart = dayjs.utc();
      pageState.dateEnd = dayjs.utc();
      pageState.placementsIncludeExclude = IncludeExclude.Include;
      pageState.countriesIncludeExclude = IncludeExclude.Include;
      pageState.campaignsIncludeExclude = IncludeExclude.Include;
      pageState.productsIncludeExclude = IncludeExclude.Include;
      pageState.trafficTypesIncludeExclude = IncludeExclude.Include;
      pageState.cLinksIncludeExclude = IncludeExclude.Include;

      searchFunction();
    }
    catch( e ){
      console.log(e);
    }

  },
  loadProductsAndCampaignsHelper: async (pageName:PageName, returnProductsAndCampaigns: boolean = true, setProductsCampaignsDto?:Function) => {
    const pageState : PageState = StateHelper.getPageState();
    const productsAndCampaigns = StateHelper.getProductsAndCampaignsState(pageName);
    if (productsAndCampaigns.dto === null || (productsAndCampaigns.dto.productsResponse === null && returnProductsAndCampaigns) || (productsAndCampaigns.dto.campaignsResponse === null && returnProductsAndCampaigns)) {
      productsAndCampaigns.dto = await CommonRequests.loadProductsAndCampaigns(pageName, pageState.dateStart, returnProductsAndCampaigns);
    }
    if (setProductsCampaignsDto) {
      setProductsCampaignsDto(productsAndCampaigns.dto);
    }
  }
};